import { attributes } from "../endpoints/attributes.endpoints";
import $axios from "../http/accessor";

const AttributesService = {
  getAllData: (page: number, count: number, search?: string) => {
    return $axios.get(attributes.get_all, {
      params: {
        page,
        count,
        search,
      },
    });
  },

  createOne: (data: FormData) => {
    return $axios.post(attributes.create, data);
  },

  getById: (id: number) => {
    return $axios.get(attributes.get_by_id(id));
  },

  deleteData: (id: number) => {
    return $axios.delete(attributes.delete(id));
  },

  updateData: (id: number, data: FormData) => {
    return $axios.put(attributes.edit(id), data);
  },
};

export default AttributesService;
